import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const initialState = { name: "", email: "", message: "" };

const EMAILJS = {
  serviceId: "service_98q4243",
  templateId: "template_t52gq2j",
  publicKey: "9ydLdz166E9ze0kS4",
};

export const Contact = ({ data }) => {
  const formRef = useRef(null);
  const [form, setForm] = useState(initialState);
  const [status, setStatus] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");

  const change = (e) => {
    setForm((value) => ({ ...value, [e.target.name]: e.target.value }));
    if (status === "error") {
      setStatus("idle");
      setErrorMessage("");
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!formRef.current || status === "sending") return;

    setStatus("sending");
    setErrorMessage("");

    try {
      const response = await emailjs.sendForm(
        EMAILJS.serviceId,
        EMAILJS.templateId,
        formRef.current,
        { publicKey: EMAILJS.publicKey }
      );

      console.info("[EmailJS] sent", response.status, response.text);
      setForm(initialState);
      setStatus("success");
    } catch (error) {
      const code = error?.status ? ` (${error.status})` : "";
      const detail = error?.text || error?.message || "Unknown EmailJS error";
      console.error("[EmailJS] failed", error);
      setStatus("error");
      setErrorMessage(`전송 실패${code}: ${detail}`);
    }
  };

  return (
    <>
      <section id="contact" className="section section--contact-v7">
        <div className="contact-bg-word" aria-hidden="true">START</div>
        <div className="site-container contact-layout-v7">
          <div className="contact-copy-v7" data-motion>
            <p className="eyebrow eyebrow-on-dark">START A PROJECT</p>
            <h2>프로젝트를<br/><span>시작해볼까요?</span></h2>
            <p>아직 범위가 정리되지 않아도 괜찮습니다. 만들고 싶은 서비스와 현재 고민부터 알려주세요.</p>
            <a href={`mailto:${data?.email}`}>{data?.email} ↗</a>
            <div>
              <a href={`tel:${data?.phone?.replace(/\s/g, "")}`}>{data?.phone}</a>
              <span>{data?.address}</span>
            </div>
          </div>

          <form ref={formRef} className="contact-form-v7" onSubmit={submit} data-motion>
            <div><span>PROJECT INQUIRY</span><span>01 — 03</span></div>
            <label className="contact-field-v73">
              <span>NAME / COMPANY</span>
              <input name="name" value={form.name} onChange={change} placeholder="성함 또는 회사명" required />
            </label>
            <label className="contact-field-v73">
              <span>EMAIL</span>
              <input name="email" type="email" value={form.email} onChange={change} placeholder="연락받을 이메일" required />
            </label>
            <label className="contact-field-v73 contact-field-v73--message">
              <span>PROJECT</span>
              <textarea name="message" value={form.message} onChange={change} rows="7" placeholder="만들고 싶은 서비스와 필요한 기능을 적어주세요." required />
            </label>
            <button disabled={status === "sending"}>
              <span>{status === "sending" ? "전송 중..." : "프로젝트 문의 보내기"}</span><b>↗</b>
            </button>
            <p className={`form-status form-status--${status}`} role="status" aria-live="polite">
              {status === "success" && "문의가 정상적으로 전송되었습니다."}
              {status === "error" && errorMessage}
            </p>
          </form>
        </div>
      </section>
      <footer className="footer-v7">
        <div className="site-container"><strong>IRUN</strong><span>DIGITAL PRODUCTS THAT WORK.</span><span>© 2026 IRUN</span></div>
      </footer>
    </>
  );
};
